import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  CompanyFilterWarehouse,
  CompanyDeleteWarehouse,
} from "../../Api/Services";
import imgDelete from "../../assets/Icon/icons8-remove-100.png";
import imgDoc from "../../assets/Icon/icons8-edit-48.png";
import { confirmAlert } from "react-confirm-alert";
import imgPlus from "../../assets/Icon/pluse.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function Warehouse() {
  const [Search, setSearch] = useState({});
  const [Data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();

  const start = async () => {
    try {
      const CompanyFilterWarehouseData = await CompanyFilterWarehouse({});
      if (
        CompanyFilterWarehouseData.status &&
        CompanyFilterWarehouseData.status === 200
      ) {
        setData(CompanyFilterWarehouseData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const Clear = async () => {
    setSearch({});
    setLoading(true);
    try {
      const CompanyFilterWarehouseData = await CompanyFilterWarehouse({});
      if (
        CompanyFilterWarehouseData.status &&
        CompanyFilterWarehouseData.status === 200
      ) {
        setData(CompanyFilterWarehouseData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const Searched = async () => {
    try {
      setLoading(true);
      const CompanyFilterWarehouseData = await CompanyFilterWarehouse({
        ...Search,
      });
      if (
        CompanyFilterWarehouseData.status &&
        CompanyFilterWarehouseData.status === 200
      ) {
        setData(CompanyFilterWarehouseData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = (e) => {
    confirmAlert({
      title: "حذف  برنامه",
      message: "آیا مطمئن هستید ؟",
      buttons: [
        {
          label: "بله",
          onClick: () => DeleteItem(e),
        },
        {
          label: "خیر",
        },
      ],
    });
  };

  const DeleteItem = async (e) => {
    try {
      setLoading(true);
      const CompanyDeleteWarehouseData = await CompanyDeleteWarehouse(e);
      if (
        CompanyDeleteWarehouseData.status &&
        CompanyDeleteWarehouseData.status === 200
      ) {
        toast.success("عملیات با موفقیت انجام شد");
        await start();
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const Add = () => {
    navigate("/Panel/Warehouses/Add");
  };

  const Edite = (id) => {
    navigate("/Panel/Warehouses/Edite/" + id);
  };

  const handleChangeSearch = (e) => {
    const newSearch = { ...Search };
    newSearch[e.target.id] = e.target.value;
    setSearch(newSearch);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-start align-items-center w-100 mb-5 pointer">
            <img
              onClick={() => {
                Add();
              }}
              src={imgPlus}
              alt=""
            />
          </div>
          <div className="d-flex justify-content-start align-items-center flex-wrap">
            <InputCus
              type="text"
              name="name"
              id="name"
              text="نام"
             className="m-2"
              value={Search.name || ""}
              onChange={handleChangeSearch}
            />
            <InputCus
              type="text"
              name="type"
              id="type"
              text="نوع"
             className="m-2"
              value={Search.type || ""}
              onChange={handleChangeSearch}
            />
          </div>
          <div className="d-flex justify-content-between align-items-center w-100 mb-3">
            <div onClick={Searched} className="btnSearch">
              جست و جو
            </div>
            <div onClick={Clear} className="btnCancel">
              بروزرسانی
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center w-100 p-2 tableC">
            <table className="table">
                  <thead className="sticky-header">
                <tr className="trTable">
                  <th>نام</th>
                  <th>نوع</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {Data.map((item, key) => (
                  <tr key={key}>
                    <td>{item.name}</td>
                    <td>{item.type}</td>
                    <td className="td-actions">
                      <span
                        className="d-inline-block pointer ms-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="حذف"
                      >
                        <img
                          height="30"
                          className="me-2"
                          src={imgDelete}
                          alt="حذف"
                          onClick={() => {
                            confirmDelete(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="ویرایش"
                      >
                        <img
                          height="30"
                          src={imgDoc}
                          alt="ویرایش"
                          onClick={() => {
                            Edite(item.id);
                          }}
                        />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Warehouse;
